import React from "react";
import { ValType } from "../../utils/ValidationFunctions";
import Form from "../../common/forms/Form";
import FormInput from "../../common/forms/FormInput";
import RegistHeader from "./RegistHeader";
import styles from "./p-register.module.scss";

type Props = {
  email: string;
  submit_handler: () => void;
  input_handler: (value: string) => void;
};

const RegistEmailForm: React.FC<Props> = ({
  email,
  submit_handler,
  input_handler,
}) => {
  return (
    <div className={styles["p-register__box"]}>
      <RegistHeader
        showLogo={true}
        title={""}
        message={"新しいeスポーツ体験を始めよう"}
      />
      <div className={styles["p-register__form"]}>
        <Form
          handler={submit_handler}
          button_id="next_button"
          button_text="次へ"
          button_class={styles["p-register__form__button"]}
        >
          <div className={styles["p-register__form__wrapper"]}>
            <FormInput
              type="textBeforeLabel"
              label="メールアドレス"
              name="sonic_email"
              val_type={ValType.Email}
              placeholder="guile@gmail.com"
              id="sonic_email"
              handler={input_handler}
              style_class={styles["p-register__form__input"]}
              label_class={styles["p-register__form__label"]}
              initial_value={email}
            />
          </div>
        </Form>
      </div>
    </div>
  );
};

export default RegistEmailForm;
